import React from 'react';

import { toast } from 'react-hot-toast';
import { Icon } from 'semantic-ui-react';

export const showToast = ({ type = 'success', message, link }) => {
  const config = {
    success: {
      icon: 'check circle',
      color: 'green',
      borderColor: '#0db791',
    },
    error: {
      icon: 'exclamation circle',
      color: 'red',
      borderColor: 'red',
    },
  };

  const { icon, color, borderColor } = config[type];

  toast.custom(
    t => (
      <div style={{
        backgroundColor: 'white',
        padding: '12px 24px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        fontSize: '16px',
        border: `1px solid ${borderColor}`,
        textAlign: 'center',
        position: 'relative',
      }}
      >
        <Icon
          size="small"
          name="close"
          style={{
            position: 'absolute',
            top: '5px',
            right: '5px',
            cursor: 'pointer',
            marginRight: '0px',
            color: 'rgba(0, 0, 0, 0.6)',
          }}
          onClick={() => toast.remove(t.id)}
        />
        <div>
          <Icon name={icon} color={color} style={{ marginRight: '8px' }} size="large" />
          <p>{message}</p>
        </div>
        {link && (
          <div style={{ textAlign: 'center' }}>
            <a href={link.href}>{link.text}</a>
          </div>
        )}
      </div>
    ),
    { duration: 5000 },
  );
};
